import { appContent } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto">
        <div className="bg-background-100 border border-background-200/30 rounded-2xl p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 mb-4">
                {appContent.title}
              </h2>
              <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                {appContent.desc}
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-6">
                {appContent.features.map((f) => (
                  <span
                    key={f}
                    className="px-3 py-1.5 rounded-full bg-background-200/50 border border-background-200/60 text-xs text-foreground-300 whitespace-nowrap"
                  >
                    {f}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-50 hover:bg-foreground-100 text-background-950 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  <i className="ri-apple-line text-lg"></i>
                  App Store
                </div>
                <div className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-50 hover:bg-foreground-100 text-background-950 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  <i className="ri-android-line text-lg"></i>
                  Google Play
                </div>
              </div>
            </div>

            <div className="shrink-0">
              <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-300/40 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20showing%20a%20cinematic%20movie%20streaming%20app%20interface%20with%20movie%20posters%20in%20grid%20layout%2C%20dark%20theme%20with%20warm%20golden%20accents%2C%20modern%20UI%20design%2C%20clean%20typography%2C%20premium%20look%2C%20isolated%20on%20transparent%20background&width=600&height=1067&seq=app-preview&orientation=portrait"
                  alt="80s电影网移动端App预览"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}